import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '@/lib/api-client';
import type { LeadFormValues } from './lead-form.schema';

/** Strips empty optional fields so the API never stores empty strings. */
const clean = (values: LeadFormValues, locale: string) => {
  const payload: Record<string, unknown> = { locale, consent: true };
  for (const [key, value] of Object.entries(values)) {
    if (key === 'consent' || key === 'website') continue;
    if (typeof value === 'string' && value.trim() === '') continue;
    payload[key] = value;
  }
  return payload;
};

export function useSubmitLead() {
  const { i18n } = useTranslation();

  return useMutation({
    mutationFn: (values: LeadFormValues) =>
      api.post<{ ok: true }>('/leads', clean(values, i18n.resolvedLanguage ?? 'de')),
  });
}
